import React from 'react';

interface AvatarBadgeProps {
    name: string;
}

export const AvatarBadge: React.FC<AvatarBadgeProps> = ({ name }) => {
    const getInitials = (fullName: string) => {
        const words = fullName.split(' ');
        return words
            .map((word) => word.charAt(0).toUpperCase())
            .slice(0, 2)
            .join(' ');
    };

    return (
        <div className='w-10 h-10 rounded-full bg-background-inversePrimary text-content-inversePrimary flex items-center justify-center text-md font-bold uppercase'>
            {getInitials(name)}
        </div>
    );
};
